<template>
  <div>
    <vs-button v-if="isSaveAvailable" ref="refMobileSaveBtn" class="absolute right-0 shadow-lg btn-back-to-top px-0" style="width: 80px; bottom: 60px" @click.stop="triggerSaveButton">저장</vs-button>
    <component :is="openType === 'popup' ? 'div' : 'vx-card'" class="w-full">
      <vs-row class="mb-6">
        <vs-col class="flex flex-col xl:flex-row gap-y-5" vs-justify="flex-end">
          <div class="mr-auto" style="display: grid; align-items: center">
            <slot name="header" :board="board" :isPrint="isPrint" />
          </div>

          <div id="right-button-container" class="w-full xl:w-auto grid grid-cols-2 xl:flex gap-2 xl:gap-4 ml-auto">
            <slot
              name="normal-board-right"
              :mode="isUpdateMode ? 'u' : 'c'"
              :func="{
                close: onClickClose, // 닫기
                move: onClickMoveList, // 목록으로 이동
                save: onClickSave, // 저장
                print: onClickPrint, // 인쇄
                delete: onClickRemove, // 삭제
                copy: onClickCopy, // 복사하기
              }"
            >
              <vs-checkbox v-if="useFinishLater" v-model="finishLater">추후보완</vs-checkbox>
              <vs-button v-if="useExcelDownload" class="ml-4" color="secondary" type="border" @click.stop.prevent="onClickDownloadExcel">Excel 내려받기</vs-button>
              <vs-button v-if="!isUpdateMode && usePrevPost" color="secondary" type="border" @click="$emit('prevPost')" class="hidden xl:block">{{ prevPostButtonLabel }}</vs-button>
              <vs-button v-if="isUpdateMode && usePrint" color="secondary" @click="onClickPrint" class="hidden xl:block">{{ printLabel }}</vs-button>
              <vs-button v-if="isDeleteAvailable" color="secondary" type="border" @click="onClickRemove">삭제</vs-button>
              <vs-button color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
              <vs-button v-if="isSaveAvailable" color="secondary" @click="onClickSave">저장</vs-button>
              <vs-button v-if="isUpdateMode && useCopyButton" color="secondary" type="border" @click="onClickCopy">복사하기</vs-button>
            </slot>
          </div>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col>
          <div id="print-report" class="overflow-x-hidden">
            <slot name="body" :board="board" :permission="permission" :isPrint="isPrint" :openType="openType" />
          </div>
        </vs-col>
      </vs-row>
    </component>
  </div>
</template>

<script>
import singlePageWrite from "@/views/boards/single-page/writeIndex";

export default {
  name: "NormalDocument",
  components: {},
  props: {
    docProjectId: String | Number,
    header: Object,
    usePrevPost: {
      type: Boolean,
      default: false,
    },
    useExcelDownload: Boolean,
    prevPostButtonLabel: {
      type: String,
      default: () => "이전 문서 불러오기",
    },
    writePrevBoardOptions: Object,
    usePrint: {
      type: Boolean,
      default: true,
    },
    usePrintTitle: {
      type: Boolean,
      default: true,
    },
    printLabel: {
      type: String,
      default: () => "인쇄",
    },
    useDelete: {
      type: Boolean,
      default: true,
    },
    created: {
      type: Boolean,
      default: true,
    },
    tab: Object,
    permission: Object | undefined,
    useFinishLater: {
      type: Boolean,
      default: false,
    },
    isFinishLater: {
      type: Boolean,
      default: false,
    },
    propsBoardId: Number,
    // PopupBoard.vue로 열릴때 popup
    // 기본상태 origin
    openType: {
      type: String,
      default: "origin",
    },
    useCopyButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    boardInfo() {
      if (this.propsBoardId) return this.propsBoardId;
      return this.$store.state.board.postInfo;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    usedDelete() {
      if (this.board.readonly) return false;
      if (this.useDelete && this.isAdmin) return true;
      // 삭제 버튼 노출 여부
      return this.useDelete && this.isUpdateMode && this.board.viewRemoveBtn && this.permission && this.permission.d && this.board.isWriter;
    },

    isUpdateMode() {
      return this.$route.params.postId > 0;
    },
    getClasses() {
      if (this.toggleSide) {
        return "fix-grid";
      }
      return "hide-grid";
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    finishLater: {
      get() {
        return this.isFinishLater;
      },
      set(value) {
        this.$emit("update:isFinishLater", value);
      },
    },

    isSaveAvailable() {
      // 작성 기능이 꺼져있으면 수정 불가
      if (!this.created || !this.board.viewSaveBtn) return false;

      // 시스템 관리자면 수정 가능
      if (this.isAdmin) return true;

      // 게시판 권한을 갖고있는지 확인한다.
      // 수정 중일 경우
      if (this.isUpdateMode) {
        if (!this.permission) return false;

        // 만약 상위 업체에서 수정 가능하도록 설정되어있으면 업체 관계를 확인한다.
        if (this.$store.state.board.boardData.editable_by_parent_company) {
          const editableCompanyIds = this.$store.state.board.postInfo.editable_company_ids;
          const myCompanyId = this.$store.state.auth.companyInfo.id;

          // 내가 상위 업체에 속한 경우,
          if (editableCompanyIds && editableCompanyIds.length > 0 && editableCompanyIds.includes(myCompanyId)) {
            return true;
          }
        }

        // 만약 같은 업체에서 수정이 가능하도록 되어 있을 경우에도 확인한다
        if (this.$store.state.board.boardData.editable_by_company_member && this.boardInfo.author) {
          const authorCompanyId = this.boardInfo.author.company_id ? this.boardInfo.author.company_id : 0;
          const myCompanyId = this.$store.state.auth.companyInfo.id;

          const editable = `${authorCompanyId}` === `${myCompanyId}`;
          if (editable) {
            return true;
          }
        }

        return !!this.permission.u;
      } else {
        // 생성 중일 경우
        return !!this.permission.c;
      }
    },
    isDeleteAvailable() {
      // 작성 기능이 꺼져있으면 수정 불가
      if (!this.isUpdateMode) return false;

      // 시스템 관리자면 수정 가능
      if (this.isAdmin) return true;
      return this.usedDelete;
    },

    componentWrite() {
      if (singlePageWrite[`${this.boardId}_write`]) {
        return singlePageWrite[`${this.boardId}_write`];
      }
    },
  },
  watch: {
    projectInfo(value) {
      if (value) {
        this.board.projectTitle = value.field_name;
      }
    },

    boardInfo(/* boardInfo */) {
      // 권한체크
      this.checkPermission();
    },

    permission(/* value */) {
      // 권한체크
      this.checkPermission();
    },

    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("board", value);
      },
    },
  },
  data() {
    return {
      isPrint: false,
      // TODO : 글쓰기 정보 및 권한
      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        author: {}, //작성자 정보
        writer: {}, //
        readonly: false, // 읽기전용인가
        isPrint: false,
        viewSaveBtn: true, //write.vue 에서 saveButtonControl 를 통해 버튼 숨김 여부를 설정
        viewRemoveBtn: true, //write.vue 에서 removeButtonControl 를 통해 버튼 숨김 여부를 설정
        isWriter: false,
      },
    };
  },
  mounted() {
    // 사용자의 업체 이름을 가져오기 위해 업체정보 호출
    this.initUserInfo();

    if (this.$refs.refMobileSaveBtn) {
      const refMobileSaveBtn = this.$refs.refMobileSaveBtn instanceof HTMLElement ? this.$refs.refMobileSaveBtn : this.$refs.refMobileSaveBtn.$el;

      if (refMobileSaveBtn) {
        // #scroll-up-btn 아래로 이동
        const scrollUpBtn = document.getElementById("scroll-up-btn");
        if (scrollUpBtn) {
          scrollUpBtn.insertAdjacentElement("afterend", refMobileSaveBtn);
          // Add click event listener to scroll-up-btn
          scrollUpBtn.addEventListener('click', this.handleScrollUp);
        }
      }
    }
  },
  beforeDestroy() {
    if (this.$refs.refMobileSaveBtn) {
      const refMobileSaveBtn = this.$refs.refMobileSaveBtn instanceof HTMLElement ? this.$refs.refMobileSaveBtn : this.$refs.refMobileSaveBtn.$el;

      if (refMobileSaveBtn && refMobileSaveBtn.parentNode) {
        refMobileSaveBtn.parentNode.removeChild(refMobileSaveBtn);
      }
    }
    // Remove click event listener
    const scrollUpBtn = document.getElementById("scroll-up-btn");
    if (scrollUpBtn) {
      scrollUpBtn.removeEventListener('click', this.handleScrollUp);
    }
  },

  methods: {
    async initUserInfo() {
      const company = await this.$store.dispatch("company/LOAD_COMPANY", { companyId: this.$store.state.auth.userInfo.company_id });

      /**
       * 가상업체 정보가 존재하는 경우 (동국제강 내부)
       * 상위 부서 정보를 department 에 담는다
       */
      let section = this.$store.state.auth.userInfo.section;
      let virtualCompany = this.$store.state.member && this.$store.state.member.memberInfo && this.$store.state.member.memberInfo.virtual_company ? this.$store.state.member.memberInfo.virtual_company : undefined;

      if (!virtualCompany) {
        await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
        virtualCompany = this.$store.state.member && this.$store.state.member.memberInfo && this.$store.state.member.memberInfo.virtual_company ? this.$store.state.member.memberInfo.virtual_company : undefined;
      }

      if (virtualCompany) {
        const fullName = virtualCompany.full_name;
        if (Array.isArray(fullName) && fullName.length > 0) {
          const index = Math.max(0, fullName.length - 2);
          section = fullName[index];
        }
      }
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        com_name: company.com_name,
        department: this.$store.state.auth.userInfo.department,
        section,
        rank: this.$store.state.auth.userInfo.rank,

        // 가상 업체 정보 추가
        virtual_company: (this.$store.state.member && this.$store.state.member.memberInfo && this.$store.state.member.memberInfo.virtual_company) ? this.$store.state.member.memberInfo.virtual_company : undefined,
      };

      // 권한체크
      this.checkPermission();
    },

    triggerSaveButton() {
      const saveButtons = document.querySelectorAll('#right-button-container .vs-button');
      for (const button of saveButtons) {
        if (button.textContent.trim() === '저장') {
          button.click();
          break;
        }
      }
    },

    checkPermission() {
      this.board.readonly = false;
      if (this.$store.state.board.postInfo.author) {
        this.board.author = {
          id: this.$store.state.board.postInfo.author.id,
          name: this.$store.state.board.postInfo.author.name,
          company_id: this.$store.state.board.postInfo.author.company_id,
          department: this.$store.state.board.postInfo.author.department,
          section: this.$store.state.board.postInfo.author.section,
          rank: this.$store.state.board.postInfo.author.rank,
          com_name: this.$store.state.board.postInfo.author.com_name,
        };

        // 글 작성자와 접속자의 정보가 다를 경우, 읽기 전용으로
        if (this.postId && this.board.author.id !== this.board.writer.id) {
          // 저장 버튼도 표시할 수 없는 상태일 경우, 읽기 전용으로 바꾼다
          if (!this.isSaveAvailable) {
            this.board.readonly = true;
          }
        } else if (this.tab.byCurrentLocation) {
          // 다른 프로젝트에서 불러왔을 경우에는 읽기전용으로
          if (this.projectId !== this.docProjectId) {
            this.board.readonly = true;
          }
        }

        this.board.isWriter = this.board.author.id === this.myInfo.id;
      }

      // 작성권한이 없을 경우 읽기전용으로 변경
      // 수정권한이 없을 경우 읽기전용으로 변경
      if (!this.permission.c || !this.permission.u) {
        this.board.readonly = true;
      }

      if (this.isAdmin) {
        this.board.readonly = false;
      }
    },

    async onClickSave(callback) {
      this.$emit("save", callback);
    },
    async onClickCopy() {
      this.$emit("copy", this.boardId, this.postId);
    },
    onClickClose() {
      this.$emit("close");
    },
    onClickDownloadExcel() {
      this.$emit("excelDownload");
    },
    onClickMoveList() {
      this.$emit("move", "list");
    },
    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; }}");
    },
    print(css) {
      // 프린트
      this.isPrint = true;
      this.board.isPrint = true;

      if (this.tab) {
        document.getElementById("hidePrintTitle").value = this.tab.hidePrintTitle ? "true" : "false";
        document.getElementById("headerDate").value = this.tab.useHeaderDate ? this.header.date || this.header.full : "false";
        document.getElementById("headerDateType").value = this.tab.headerDateType || "yearMonth";
      }
      document.getElementById("isPrint").value = "true";

      setTimeout(() => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (let i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML.trimStart().trimEnd().replace(/\r\n/gi, "<br>").replace(/\\n/gi, "<br>").replace(/\n/gi, "<br>");

          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }
        const isPrint = document.getElementById("isPrint").value === "true";
        const hidePrintTitle = document.getElementById("hidePrintTitle").value === "true";
        const headerDate = document.getElementById("headerDate").value !== "false" ? document.getElementById("headerDate").value : false;
        const headerDateType = document.getElementById("headerDateType").value;

        const g_label = document.getElementById("print-label") ? document.getElementById("print-label").innerHTML : "";
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = "";
          if (g_label && isPrint && !hidePrintTitle) {
            let title = "";
            title += '<div class="flex gap-4 mb-4">';
            title += `<p class="flex" style="align-items: center">${g_label}</p>`;
            if (headerDate) {
              let date = headerDate;
              if (headerDateType === "date") {
                //
              } else if (headerDateType === "yearMonth") {
                const _ym = headerDate.split("-");
                date = `${_ym[0]}년 ${_ym[1]}월`;
              }
              title += `<div class="print-input" style="font-size: 16px; width: 120px; background: #f9f9f9;">${date}</div>`;
            }
            title += "</div>";
            document.body.innerHTML += title;
          }
          document.body.innerHTML += g_oBeforeBody;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        window.print();
        location.reload();
      }, 300);
    },
    onClickPrint() {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-vertical.svg" },
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-horizontal.svg" },
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },
    onClickRemove() {
      // 수정중
      if (this.isUpdateMode) {
        this.$emit("remove");
      } else /* 작성중 */ {
        this.$emit("move", "list");
      }
    },
    saveButtonControl(value) {
      this.board.viewSaveBtn = value;
    },
    removeButtonControl(value) {
      this.board.viewRemoveBtn = value;
    },
    handleScrollUp(e) {
      // Prevent default scroll behavior
      e.preventDefault();
      e.stopPropagation();

      const component = this.componentWrite;
      if (component && typeof component.methods.clickPageTop === 'function') {
        // If changeTop method exists, call it
        component.methods.clickPageTop();
      } else {
        // Default behavior: scroll to top
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fix-grid {
  display: grid !important;
  grid-template-columns: 9fr 3fr;
}

.hide-grid {
  display: grid !important;
  grid-template-columns: 9fr 0px;
}

.toggle-btn {
  padding: 0.5rem !important;
  height: 100%;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background-color: lightgray;
  color: #fff;
}
</style>
<style>
.con-vs-tabs .con-slot-tabs {
  overflow: initial;
}
</style>
